import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { appInsights } from "./ApplicationInsightsService";
import axios from "axios";

const BaseURL = `${process.env.REACT_APP_API_URL}/filetransfer`;
const Ocp_Apim_Subscription_Key = `${process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY}`;
const X_OSF_Caller = `${process.env.REACT_APP_X_OSF_CALLER}`;

function generateHeader(accessToken) {
  const bearer = `Bearer ${accessToken}`;
  const headersObj = {
    Authorization: bearer,
    "Content-Type": "application/json",
    "Ocp-Apim-Subscription-Key": Ocp_Apim_Subscription_Key,
    "X-OSF-Caller": X_OSF_Caller,
  };
  return headersObj;
}

export async function getAllLinkedServices(accessToken) {
  const URL = BaseURL + `/getalllinkedservices`;
  appInsights.trackEvent({
    name: `GET call for ${URL} started`,
  });
  try {
    // const headers = generateHeader(accessToken);
    const bearer = `Bearer ${accessToken}`;
    const config = {
      headers: {
        Authorization: bearer,
        "Content-Type": "application/json",
        "Ocp-Apim-Subscription-Key": Ocp_Apim_Subscription_Key,
        "X-OSF-Caller": X_OSF_Caller,
      },
    };
    const options = {
      url: URL,
      method: "GET",
      headers: config.headers,
    };
    const response = await axios(options);
    appInsights.trackEvent({
      name: `GET call for ${URL} Completed`,
    });
    return response;
  } catch (error) {
    appInsights.trackException({
      error: new Error(`Error while Calling ${URL} - ${error}`),
      severityLevel: SeverityLevel.Error,
    });
    throw error;
  }
}
// look up services

export async function getAllLookUpData(payload, accessToken) {
  const URL = BaseURL + `/GetAllLookUpData`;
  console.log(URL);
  appInsights.trackEvent({
    name: `GET call for ${URL} started`,
  });
  try {
    const headers = generateHeader(accessToken);
    const options = {
      method: "POST",
      headers: headers,
      data: payload,
      url: URL,
    };
    const response = await axios(options);
    appInsights.trackEvent({
      name: `GET call for ${URL} completed`,
    });

    return response;
  } catch (error) {
    appInsights.trackException({
      error: new Error(error),
      severityLevel: SeverityLevel.Error,
      properties: { message: `Error while Calling ${URL} - ${error}` },
    });
    throw error;
  }
}

export async function deleteLookup(payload, accessToken) {
  const URL = BaseURL + `/DeleteLookUpData`;
  appInsights.trackEvent({
    name: `DELETE call for ${URL} started`,
  });

  try {
    const headers = generateHeader(accessToken);
    const options = {
      method: "DELETE",
      headers: headers,
      data: payload,
      url: URL,
    };
    const response = await axios(options);
    appInsights.trackEvent({
      name: `DELETE call for ${URL} Completed`,
    });
    return response;
  } catch (error) {
    appInsights.trackException({
      error: new Error(error),
      severityLevel: SeverityLevel.Error,
      properties: { message: `Error while Calling ${URL} - ${error}` },
    });
    throw error;
  }
}

export async function updateLookup(payload, accessToken) {
  try {
    const URL = BaseURL + `/UpdateLookUpData`;
    appInsights.trackEvent({
      name: `PUT call for ${URL} started`,
    });
    const headers = generateHeader(accessToken);

    const options = {
      method: "PUT",
      headers: headers,
      data: payload,
      url: URL,
    };
    const response = await axios(options);
    appInsights.trackEvent({
      name: `PUT call for ${URL} completed`,
    });
    return response;
  } catch (error) {
    appInsights.trackException({
      error: new Error(error),
      severityLevel: SeverityLevel.Error,
      properties: { message: `Error while Calling ${URL} - ${error}` },
    });
    throw error;
  }
}

export async function updatePipeline(payload, accessToken) {
  try {
    const URL = BaseURL + `/UpdatePipeline`;
    appInsights.trackEvent({
      name: `PUT call for ${URL} started`,
    });
    const headers = generateHeader(accessToken);

    const options = {
      method: "PUT",
      headers: headers,
      data: payload,
      url: URL,
    };
    const response = await axios(options);
    appInsights.trackEvent({
      name: `PUT call for ${URL} completed`,
    });
    return response;
  } catch (error) {
    appInsights.trackException({
      error: new Error(error),
      severityLevel: SeverityLevel.Error,
      properties: { message: `Error while Calling ${URL} - ${error}` },
    });
    throw error;
  }
}

//pipeline services
export async function createPipeline(payload, accessToken) {
  try {
    const URL = BaseURL + `/CreatePipeline`;
    appInsights.trackEvent({
      name: `POST call for ${URL} started`,
    });
    const headers = generateHeader(accessToken);

    const options = {
      method: "PUT",
      headers: headers,
      mode: "cors",
      data: payload,
      url: URL,
    };
    const response = await axios(options);
    appInsights.trackEvent({
      name: `POST call for ${URL} started`,
    });
    return response;
  } catch (error) {
    appInsights.trackException({
      error: new Error(error),
      severityLevel: SeverityLevel.Error,
      properties: { message: `Error while Calling ${URL} - ${error}` },
    });
    throw error;
  }
}

export async function deletePipeline(payload, accessToken) {
  try {
    const URL = BaseURL + `/DeletePipeline`;
    console.log(BaseURL);
    appInsights.trackEvent({
      name: `DELETE call for ${URL} started`,
    });
    const headers = generateHeader(accessToken);

    const options = {
      headers: headers,
      url: URL,
      method: "DELETE",
      data: payload,
    };
    const response = await axios(options);
    appInsights.trackEvent({
      name: `DELETE call for ${URL} completed`,
    });
    return response;
  } catch (error) {
    appInsights.trackException({
      error: new Error(error),
      severityLevel: SeverityLevel.Error,
      properties: { message: `Error while Calling ${URL} - ${error}` },
    });
    throw error;
  }
}

export async function getAllPipelines(payload, accessToken) {
  try {
    const URL = BaseURL + `/GetAllPipelines`;
    appInsights.trackEvent({
      name: `GET call for ${URL} started`,
    });
    const headers = generateHeader(accessToken);

    const options = {
      method: "POST",
      headers: headers,
      data: payload,
      url: URL,
    };

    const response = await axios(options);
    appInsights.trackEvent({
      name: `GET call for ${URL} completed`,
    });
    return response;
  } catch (error) {
    appInsights.trackException({
      error: new Error(error),
      severityLevel: SeverityLevel.Error,
      properties: { message: `Error while Calling ${URL} - ${error}` },
    });
    throw error;
  }
}

export async function getAllSourceDestinationTypes(accessToken) {
  try {
    const URL = BaseURL + `/GetAlltypes`;
    appInsights.trackEvent({
      name: `GET call for ${URL} started`,
    });
    const headers = generateHeader(accessToken);

    const options = {
      url: URL,
      method: "GET",
      headers: headers,
      data:{}
     
    };

    const response = await axios(options,);
    appInsights.trackEvent({
      name: `GET call for ${URL} completed`,
    });
    return response;
  } catch (error) {
    appInsights.trackException({
      error: new Error(error),
      severityLevel: SeverityLevel.Error,
      properties: { message: `Error while Calling ${URL} - ${error}` },
    });
    throw error;
  }
}


export async function getPipeline(id , accessToken) {
  try {
    const URL = BaseURL + `/getpipeline/`+id;
    appInsights.trackEvent({
      name: `GET call for ${URL} started`,
    });
    const headers = generateHeader(accessToken);

    const options = {
      url: URL,
      method: "GET",
      headers: headers,
      data:{}
     
    };

    const response = await axios(options,);
    appInsights.trackEvent({
      name: `GET call for ${URL} completed`,
    });
    return response;
  } catch (error) {
    appInsights.trackException({
      error: new Error(error),
      severityLevel: SeverityLevel.Error,
      properties: { message: `Error while Calling ${URL} - ${error}` },
    });
    throw error;
  }
}





